'use client';
import e$1 from 'prop-types';
import * as e from 'react';
import { deprecatedProp } from '../core/deprecated-prop.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

function _define_property(t, e, n) {
    return e in t ? Object.defineProperty(t, e, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : t[e] = n, t;
}
function _object_spread(t) {
    for(var e = 1; e < arguments.length; e++){
        var n = null != arguments[e] ? arguments[e] : {}, r = Object.keys(n);
        "function" == typeof Object.getOwnPropertySymbols && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(t) {
            return Object.getOwnPropertyDescriptor(n, t).enumerable;
        }))), r.forEach(function(e) {
            _define_property(t, e, n[e]);
        });
    }
    return t;
}
function ownKeys(t, e) {
    var n = Object.keys(t);
    if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        n.push.apply(n, r);
    }
    return n;
}
function _object_spread_props(t, e) {
    return e = null != e ? e : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(e)) : ownKeys(Object(e)).forEach(function(n) {
        Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(e, n));
    }), t;
}
const buttonPropTypes = {
    skin: e$1.oneOf([
        'unstyled',
        'link',
        'primary',
        'secondary',
        'tertiary',
        'clear-selection'
    ]),
    size: deprecatedProp(e$1.oneOf([
        'standard',
        'mini'
    ]), 'Sizing is now handled automatically by standardMode/compactMode'),
    width: e$1.oneOf([
        'standard',
        'full-width',
        'wide'
    ]),
    specialVariant: e$1.oneOf([
        'standard',
        'design-path'
    ]),
    iconPosition: e$1.oneOf([
        'right',
        'left'
    ]),
    buttonShape: e$1.oneOf([
        'standard',
        'round'
    ])
};
let a = Object.keys(buttonPropTypes);
const Button = renderWithRef('Button', buttonPropTypes, (t, n)=>{
    var o;
    let { as: s, component: d, skin: i = 'secondary', size: c = 'standard', width: p = 'standard', specialVariant: u = 'standard', iconPosition: b, buttonShape: l = 'standard', children: y, type: f } = t, w = null !== (o = null != s ? s : d) && void 0 !== o ? o : 'button', O = ![
        'unstyled',
        'clear-selection',
        'link'
    ].includes(null != i ? i : 'secondary'), g = new Set([]);
    return O && (g.add('swan-button'), g.add(`swan-button-skin-${i}`)), O || g.add(`swan-button-skin-${i}`), 'round' === l && g.add('swan-button-round'), 'left' === b && g.add('swan-button-with-icon-left'), 'right' === b && g.add('swan-button-with-icon-right'), ('design-path' !== u || b) && 'right' !== b || g.add('swan-button-with-icon-right'), 'standard' !== c && O && g.add(`swan-button-${c}`), 'standard' === c || O || g.add(`swan-button-${c}`), 'standard' !== p && g.add(`swan-button-${p}`), 'design-path' === u && g.add("swan-button-design-path"), e.createElement(RenderComp, {
        root: "button",
        forwardedRef: n,
        propKeysToRemove: a,
        classNames: g,
        props: 'button' === w || 'input' === w ? _object_spread_props(_object_spread({}, t), {
            type: 'button' === w || 'input' === w ? null != f ? f : 'button' : f
        }) : t
    }, y);
});

export { Button, buttonPropTypes };
